import { useStaticQuery, graphql } from 'gatsby'

export const getBoardMemberHeroData = () => {
  const { allStrapiCommonHero } = useStaticQuery(boardMemberHeroDataQuery)
  let boardMemberHeroData = allStrapiCommonHero.nodes[0].Heros.filter(
    value => Object.keys(value).length !== 0
  )
  return boardMemberHeroData[0]
}

const boardMemberHeroDataQuery = graphql`
  query {
    allStrapiCommonHero {
      nodes {
        Heros {
          ... on STRAPI__COMPONENT_SHARED_BOARD_MEMBERS_HERO {
            id
            button {
              id
              name
              url
            }
            description {
              data {
                description
              }
            }
            title
          }
        }
      }
    }
  }
`
